import React from 'react';
import HeaderBottom from './HeaderBottom';
import PricingSection from './PricingSection';

const PricingPage = () => {
    return (
        <div className="boxed_wrapper ltr">
            <HeaderBottom />
            <PricingSection />
        </div>
    );
};

export default PricingPage;
